import React from "react";
import { useSelector } from "react-redux";

const BI_BETA_URL = "https://demo041112.z13.web.core.windows.net";

const BiBetaPage = () => {
  const userId = useSelector((state) => state.userState?.user?.user_id);
  const biBetaUrl = userId ? `${BI_BETA_URL}?user_id=${encodeURIComponent(userId)}` : BI_BETA_URL;

  return (
    <div className="bi-beta-page">
      <iframe
        className="bi-beta-frame"
        src={biBetaUrl}
        title="BI Beta"
        allow="fullscreen"
      />
    </div>
  );
};

export default BiBetaPage;
